import axios from "axios";
import React, { useState, useEffect } from "react";
import Modal from "../modals/Modal";
import style from "styled-components";
import {
  Form,
  InputContainer,
  ButtonsContainer,
  Button,
  ErrorSpan,
  ButtonsContainerTuPay,
  AmountButton,
} from "./DepositElements";
import { useTranslation } from "react-i18next";
import { formatNumber, toLocaleString } from "../../utils/tools";
import { useSelector } from "react-redux";
import { selectCurrency, selectId } from "../../features/user/userSlice";
import ecuadorpasarelas from "../../assets/images/ecuadormonnetoficial.png";
import monnetpasarelas from "../../assets/images/chilepasa01.png";
import perupasarelas from "../../assets/images/perumonnetoficial.png";
import Ralps from "../../assets/images/RECARGACONVALPS.svg";
import { selectLimites } from "../../features/limitaciones/limitacionesSlice";

const FormAlps = ({
  form,
  handleChange,
  handleClose,
  handleSubmit,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const id_uo = useSelector(selectId);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);
  const [monedaAux, setmonedaAux] = useState(() => {
    if (moneda === "$") return "USD";
    if (moneda === "Sol") return "PEN";
    if (moneda === "CLP") return "CLP";
    return moneda;
  });
  const [entidades, setEntidades] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const limitaciones = useSelector(selectLimites);

  const monedasLimites = {
    Sol: {minimo: 100, maximo: 10000},
    CLP: {minimo:10000, maximo: 10000000},
    $: {minimo: 20, maximo: 5000}
  }

  const [minimo, setMinimo] = useState(monedasLimites[moneda].minimo)
  const [maximo, setMaximo] = useState(monedasLimites[moneda].maximo)

  useEffect(()=>{
    if(limitaciones.minimo_deposito>0 && limitaciones.minimo_deposito > minimo) setMinimo(limitaciones.minimo_deposito) 
    if(limitaciones.maximo_deposito>0 && limitaciones.maximo_deposito < maximo) setMaximo(limitaciones.maximo_deposito) 
  },[limitaciones])



  // Función para realizar la solicitud GET para bancos
  const fetchEntidades = async () => {
    try {
      const response = await axios.get(
        `https://app.masterbets365.com/API/Api-Alps/index.php/api/channels/${monedaAux}`
      );
      const entidadesHabilitadas = response.data.data;
      setEntidades(entidadesHabilitadas);
    } catch (error) {
      console.error("Error fetching entidades:", error);
    }
  };

  // Función para realizar la solicitud GET para documentos
  const fetchDocumentos = async () => {
    try {
      const response = await axios.get(
        `https://app.masterbets365.com/API/Api-Alps/index.php/api/documentTypes/${id_uo}`
      );
      const documentosHabilitados = response.data.data;
      setDocumentos(documentosHabilitados);
    } catch (error) {
      console.error("Error fetching documentos:", error);
    }
  };

  useEffect(() => {
    fetchEntidades();
    fetchDocumentos();
  }, []);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  const changeAmount = (valor) => {
    handleMonto({ target: { value: valor, name: "monto1" } });
  };

  return (
    <Form className={"tupay"}>
      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
      </InputContainer>
      {moneda === "CLP" ? (
        <AmountButton>
          <Button
            onClick={() => {
              changeAmount("20.000,00");
            }}
          >
            20.000 CLP
          </Button>
          <Button
            onClick={() => {
              changeAmount("50.000,00");
            }}
          >
            50.000 CLP
          </Button>
          <Button
            onClick={() => {
              changeAmount("100.000,00");
            }}
          >
            100.000 CLP
          </Button>
          <Button
            onClick={() => {
              changeAmount("200.000,00");
            }}
          >
            200.000 CLP
          </Button>
        </AmountButton>
      ) : moneda === "$" ? (
        <AmountButton>
          <Button
            onClick={() => {
              changeAmount("20,00");
            }}
          >
            $20
          </Button>
          <Button
            onClick={() => {
              changeAmount("50,00");
            }}
          >
            $50
          </Button>
          <Button
            onClick={() => {
              changeAmount("100,00");
            }}
          >
            $100
          </Button>
          <Button
            onClick={() => {
              changeAmount("200,00");
            }}
          >
            $200
          </Button>
        </AmountButton>
      ) : moneda === "Sol" ? (
        <AmountButton>
          <Button
            onClick={() => {
              changeAmount("100,00");
            }}
          >
            S/100
          </Button>
          <Button
            onClick={() => {
              changeAmount("150,00");
            }}
          >
            S/150
          </Button>
          <Button
            onClick={() => {
              changeAmount("200,00");
            }}
          >
            S/200
          </Button>
          <Button
            onClick={() => {
              changeAmount("500,00");
            }}
          >
            S/500
          </Button>
        </AmountButton>
      ) : null}

      <InputContainer>
        <label>{t("deposit.methodPayment")}</label>
        <select value={form.channel} onChange={handleChange} name="channel">
          <option disabled value="">
            {t("deposit.selectpayment")}
          </option>
          {entidades.map((entidad) => (
            <option key={entidad.code} value={entidad.code}>
              {`${entidad.name} - ${entidad.partner}`}
            </option>
          ))}
        </select>
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.documentType")}:</label>
        <select
          value={form.document_type}
          onChange={handleChange}
          name="document_type"
        >
          <option disabled value="">
            {t("deposit.select-document-type")}
          </option>
          {documentos.map((documento) => (
            <option key={documento} value={documento}>
              {documento}
            </option>
          ))}
        </select>
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.id")}</label>
        <input
          type="text"
          placeholder={t("deposit.id")}
          name="document"
          value={form.document}
          onChange={handleChange}
        />
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto1"
          value={form.monto1}
          onChange={(e) => handleMonto(e)}
        />

              {monto < minimo && blur && (
                <ErrorSpan>
                  {t("deposit.amount-greater-than")} {toLocaleString(minimo)} {moneda}{" "}
                </ErrorSpan>
              )}

              {monto > maximo && blur && (
                <ErrorSpan>
                  {t("deposit.amount-less-than")} {toLocaleString(maximo)} {moneda}{" "}
                </ErrorSpan>
              )}

        {/* {limitaciones.minimo_deposito > 0 && (
          <>
            {moneda === "Sol" &&
              (limitaciones.minimo_deposito > 100
                ? monto < limitaciones.minimo_deposito
                : monto < 100) &&
              blur && (
                <ErrorSpan>
                  {t("deposit.amount-greater-than")}{" "}
                  {limitaciones.minimo_deposito > 100
                    ? limitaciones.minimo_deposito
                    : "100"}{" "}
                  {moneda}{" "}
                </ErrorSpan>
              )}

            {moneda === "CLP" &&
              (limitaciones.minimo_deposito > 10000
                ? monto < limitaciones.minimo_deposito
                : monto < 10000) &&
              blur && (
                <ErrorSpan>
                  {t("deposit.amount-greater-than")}{" "}
                  {limitaciones.minimo_deposito > 10000
                    ? limitaciones.minimo_deposito
                    : "10.000"}{" "}
                  {moneda}{" "}
                </ErrorSpan>
              )}

            {moneda === "$" &&
              (limitaciones.minimo_deposito > 20
                ? monto < limitaciones.minimo_deposito
                : monto < 20) &&
              blur && (
                <ErrorSpan>
                  {t("deposit.amount-greater-than")} {moneda}
                  {limitaciones.minimo_deposito > 20
                    ? limitaciones.minimo_deposito
                    : "20"}{" "}
                </ErrorSpan>
              )}
          </>
        )}

        {limitaciones.maximo_deposito > 0 && (
          <>
            {moneda === "Sol" &&
              (limitaciones.maximo_deposito < 10000
                ? monto > limitaciones.maximo_deposito
                : monto > 10000) &&
              blur && (
                <ErrorSpan>
                  {t("deposit.amount-less-than")}{" "}
                  {limitaciones.maximo_deposito < 10000
                    ? limitaciones.maximo_deposito
                    : "10.000"}{" "}
                  {moneda}{" "}
                </ErrorSpan>
              )}

            {moneda === "CLP" &&
              (limitaciones.maximo_deposito < 10000000
                ? monto > limitaciones.maximo_deposito
                : monto > 10000000) &&
              blur && (
                <ErrorSpan>
                  {t("deposit.amount-less-than")}{" "}
                  {limitaciones.maximo_deposito < 10000000
                    ? limitaciones.maximo_deposito
                    : "10.000.000"}{" "}
                  {moneda}{" "}
                </ErrorSpan>
              )}

            {moneda === "$" &&
              (limitaciones.maximo_deposito < 5000
                ? monto > limitaciones.maximo_deposito
                : monto > 5000) &&
              blur && (
                <ErrorSpan>
                  {t("deposit.amount-less-than")} {moneda}
                  {limitaciones.maximo_deposito < 5000
                    ? limitaciones.maximo_deposito
                    : "5.000"}{" "}
                </ErrorSpan>
              )}
          </>
        )}

        {limitaciones.minimo_deposito === 0 && (
            <>
              {moneda === "Sol" && monto < 100 && blur && (
                <ErrorSpan>
                  {t("deposit.amount-greater-than")} 100 {moneda}{" "}
                </ErrorSpan>
              )}

              {moneda === "CLP" && monto < 10000 && blur && (
                <ErrorSpan>
                  {t("deposit.amount-greater-than")} 10.000 {moneda}{" "}
                </ErrorSpan>
              )}

              {moneda === "$" && monto < 20 && blur && (
                <ErrorSpan>
                  {t("deposit.amount-greater-than")} {moneda}20{" "}
                </ErrorSpan>
              )}
            </>
          )}
        {limitaciones.maximo_deposito === 0 && (
            <>
              {moneda === "Sol" && monto > 10000 && blur && (
                <ErrorSpan>
                  {t("deposit.amount-less-than")} 10.000 {moneda}{" "}
                </ErrorSpan>
              )}
              {moneda === "CLP" && monto > 10000000 && blur && (
                <ErrorSpan>
                  {t("deposit.amount-less-than")} 10.000.000 {moneda}{" "}
                </ErrorSpan>
              )}
              {moneda === "$" && monto > 5000 && blur && (
                <ErrorSpan>
                  {t("deposit.amount-less-than")} {moneda}5.000{" "}
                </ErrorSpan>
              )}
            </>
          )} */}
      </InputContainer>

      <img
        src={Ralps}
        alt="Ralps"
        className={"tupa1"}
        style={{ width: "40%", marginLeft: "30%", marginTop: "5%" }}
      />
      {moneda === "CLP" && (
        <img
          src={monnetpasarelas}
          alt="Pasarelas Monnet"
          className={"tupa2"}
          style={{ width: "100%", marginTop: "0.5%", marginLeft: "0.2%" }}
        />
      )}
      {moneda === "$" && (
        <img
          src={ecuadorpasarelas}
          alt="Pasarelas Monnet"
          className={"tupa2"}
          style={{ width: "100%", marginTop: "0.5%", marginLeft: "0.2%" }}
        />
      )}

      {moneda === "Sol" && (
        <img
          src={perupasarelas}
          alt="Pasarelas Monnet"
          className={"tupa2"}
          style={{ width: "100%", marginTop: "0.5%", marginLeft: "0.2%" }}
        />
      )}
      <ButtonsContainer style={{ marginTop: "-120px" }}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-back")}
        </Button>
            <Button
              primary={true}
              disabled={
                loading || monto < minimo || monto>maximo
                /* (monto < 100 && moneda === "Sol") ||
                (monto > 10000 && moneda === "Sol") ||
                (monto < 10000 && moneda === "CLP") ||
                (monto > 10000000 && moneda === "CLP") ||
                (monto < 20 && moneda === "$") ||
                (monto > 5000 && moneda === "$") */
              }
              onClick={handleSubmit}
            >
              {loading ? t("deposit.loading") : t("deposit.btn-next")}
            </Button>

      </ButtonsContainer>
    </Form>
  );
};

export default FormAlps;
